"use strict";

var _interopRequireDefault = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.regexp.test.js");

var _classCallCheck2 = _interopRequireDefault(require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/createClass.js"));

var Regular = /*#__PURE__*/function () {
  function Regular() {
    (0, _classCallCheck2.default)(this, Regular);
  }

  (0, _createClass2.default)(Regular, null, [{
    key: "isPassword",
    value: function isPassword(str) {
      var res = /(?!^\d+$)(?!^[A-Za-z]+$)(?!^[^A-Za-z0-9]+$)(?!^.*[\u4E00-\u9FA5].*$)^\S{6,14}$/;
      return res.test(str);
    } // 校验手机号

  }, {
    key: "isMobile",
    value: function isMobile(str) {
      var re = /^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/;
      return re.test(str);
    } // 校验固定电话

  }, {
    key: "isFixedTel",
    value: function isFixedTel(str) {
      var re = /^((0\d{2,3})-)(\d{7,8})?$/;
      return re.test(str);
    } // 用户名验证

  }, {
    key: "checkName",
    value: function checkName(str) {
      var re = /^(?!_)(?!.*?_$)[a-zA-Z\u4e00-\u9fa5]{0,10}$/; // 只含有汉字、数字、字母、下划线不能以下划线开头和结尾    //下划线位置不限^[a-zA-Z0-9_\u4e00-\u9fa5]+$

      return re.test(str);
    } // 校验邮箱

  }, {
    key: "isEmail",
    value: function isEmail(str) {
      var re = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/; // /^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/g

      return re.test(str);
    } // 检验姓名(可检验少数民族)

  }, {
    key: "isName",
    value: function isName(str) {
      var reg = /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/;
      return reg.test(str);
    }
  }]);
  return Regular;
}();

exports.default = Regular;